export default function FullScreenLayout({ children }: { children: React.ReactNode }) {
  return <main className="main-container">{children}</main>;
}
